import { render, staticRenderFns } from "./DetaiCampusAvantage1.vue?vue&type=template&id=ef0f2fea"
import script from "./DetaiCampusAvantage1.vue?vue&type=script&lang=js"
export * from "./DetaiCampusAvantage1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports